module.exports = __webpack_public_path__ + "img/bk_509.f4fcab4c.png";